var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransistor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 154,
    viewBox: "0 0 77 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4878 20.5294C41.3223 20.5294 43.6201 18.2316 43.6201 15.3971C43.6201 12.5626 41.3223 10.2648 38.4878 10.2648C35.6533 10.2648 33.3555 12.5626 33.3555 15.3971C33.3555 18.2316 35.6533 20.5294 38.4878 20.5294Z",
    fill: "#81D4A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3972H5.1323V28.2279H0V15.3972Z",
    fill: "#81D4A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8555 15.3972H76.9878V28.2279H71.8555V15.3972Z",
    fill: "#81D4A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.15527e-05V10.2647H7.69846C9.11754 10.2647 10.2646 11.4118 10.2646 12.8309V30.7939C10.2646 32.213 9.11754 33.3601 7.69846 33.3601H0V76.9847H76.9846V33.3601H69.2861C67.867 33.3601 66.72 32.213 66.72 30.7939V12.8309C66.72 11.4118 67.867 10.2647 69.2861 10.2647H76.9846V9.15527e-05H0ZM38.4923 25.6616C32.8314 25.6616 28.2277 21.0579 28.2277 15.397C28.2277 9.73607 32.8314 5.1324 38.4923 5.1324C44.1532 5.1324 48.7569 9.73607 48.7569 15.397C48.7569 21.0579 44.1532 25.6616 38.4923 25.6616Z",
    fill: "#40336F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3555 97.5139H35.9216V153.969H41.0539V97.5139H43.6201V82.117H33.3555V97.5139Z",
    fill: "#221E3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 97.5139H7.69115V153.969H12.8235V97.5139H15.3896V82.117H5.125V97.5139Z",
    fill: "#221E3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.582 97.5139H64.1482V153.969H69.2805V97.5139H71.8466V82.117H61.582V97.5139Z",
    fill: "#221E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransistor);
export default __webpack_public_path__ + "static/media/transistor.d2c50f25471a97182b621311c438a1ea.svg";
export { ForwardRef as ReactComponent };